/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

/* eslint-disable react/state-in-constructor */
import { Component, ErrorInfo, ReactNode } from "react";
import { Error } from "@mui/icons-material";
import { Button } from "@mui/material";

import NonIdealState from "./NonIdealState";

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  props: Props;

  constructor(props: Props) {
    super(props);
    this.props = props;
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <NonIdealState
          size="small"
          icon={<Error />}
          description="Sorry.. there was an error"
          action={
            <Button
              size="small"
              variant="contained"
              color="primary"
              onClick={() => {
                window.location.reload();
              }}
            >
              Refresh
            </Button>
          }
        />
      );
    }

    return children;
  }
}

export default ErrorBoundary;
